// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"10973840","400":"33a0d927"}[chunkId] + ".chunk.js";
};